import React from 'react';
import { NavLink } from 'react-router-dom'

import Logo from '../../../assets/images/ImagesSociete/Logo-webSite-AD.svg';

function LogoWebSiteFooter() {
  return (
    <>
      <NavLink to="/">
        <img
          className="w-8 lg:w-10 mb-2"
          alt="AD"
          title="Arnaud Desportes, developpeur web Front-End Freelance"
          src={Logo}
        />
      </NavLink>
    </>
  );
}

export default LogoWebSiteFooter;